module.exports = __webpack_public_path__ + "img/bw.559667b5.svg";